import { SubscriptionPlan, ProductsUniqueIds, UserDetailsFormData } from "../../../../../global/paywall/paywallInterfaces";
import { SettingLinks } from "../premiumPaywallCheckout";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink"
import { TargetOptions } from "../../../../../global/components/linkSettings/targetOptions"
import { CustomerDetails } from "../../../../../global/paywall/useDetailsUpdate";

interface PaywallCheckoutFinishProps {
    setShouldRedirect: (shouldRedirect: boolean) => void;
    selectedPlan: SubscriptionPlan | null;
    customerDetails: CustomerDetails;
    settingLinks: SettingLinks;
    nextStep: () => void;
}

const PaywallCheckoutFinish = (props: PaywallCheckoutFinishProps) => {

    const { setShouldRedirect, selectedPlan, customerDetails, settingLinks } = props;
    const { myAccount } = settingLinks;
    const isMonthly = selectedPlan.productUniqueId === ProductsUniqueIds.MONTHLY_PASS;
    const planTitle = isMonthly ? "חבילה בחיוב חודשי מתחדש" : "חבילה בחיוב שנתי מתחדש";
    const planPrice = isMonthly ? "₪29.90 לחודש" : "₪299.90 לשנה";
    const { firstName, lastName, email, phoneNumber } = customerDetails;
    const handleEventShouldRedirect = () => {
        setShouldRedirect(true);
        const redirectEvent = new CustomEvent("redirectEvent");
        document.dispatchEvent(redirectEvent);
    };

    return (
        <div className="PaywallCheckoutFinish">
            <div className="title-container">
                <span className="success-logo"></span>
                <span className="title">הרכישה הושלמה!</span>
            </div>
            <div className="subtitle">
                מעכשיו תוכלו ליהנות מגישה חופשית לכל תכני ידיעות+ ולמהדורה הדיגיטלית של
                <span className="yedioth-logo"></span>
            </div>

            <div className="checkout-container">
                <div className="plan-info">
                    <div className="plan-title">{planTitle}</div>
                    <div className="plan-price-text">{planPrice}</div>
                </div>
                <div className="customer-info">
                    <div className="customer-title">פרטי המנוי</div>
                    <div className="inner-container">
                        <div className="customer-name">{firstName + " " + lastName}</div>
                        <div className="customer-email">{email}</div>
                        <div className="custome-phone">{phoneNumber}</div>
                    </div>
                    <div className="customer-myaccount-info">ניתן לצפות ולערוך את פרטי המנוי <HyperLinkBuilder href={myAccount.url} linkTarget={myAccount.target} className="underline">באזור האישי</HyperLinkBuilder></div>
                </div>
            </div>

            <button className="continue-button" onClick={() => handleEventShouldRedirect()}>מעבר לכתבות ידיעות+</button>


        </div>
    );
};

export default PaywallCheckoutFinish;